import { Box, styled, Theme } from '@mui/material';

export const SendMessageBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  };
});
